<template lang="pug">
.content-wrap
  topbar
  .content-top
    .con
      //- highlight
      rtt
      .cat-tab.nbswi(ref="categories")
        .swiper.glcat-swiper.nbswi-swiper
          .swiper-wrapper
            //- .swiper-slide
              .cat(@click="redirectPath('/')")
                img(src='/new/img/tab/c-hot.png')
                | hot
            .swiper-slide
              .cat(@click="redirectPath('/slot')")
                img(src='/new/img/tab/c-slot.png')
                | slots
            template(v-if="isLoggedIn")
              .swiper-slide
                router-link.cat(to="/launchWbet" target="_blank")
                  img(src='/new/img/tab/c-sport.png')
                  | sports
            template(v-else)
              .swiper-slide
                a.cat(@click="$router.push('/login').catch(err => {})")
                  img(src='/new/img/tab/c-sport.png')
                  | sports
            .swiper-slide
              .cat.aaa
                img(src='/new/img/tab/c-casino.png')
                | live
            .swiper-slide
              .cat(@click="redirectPath('/table')")
                img(src='/new/img/tab/c-poker.png')
                | poker
            //- .swiper-slide
              .cat(@click="redirectPath('/bingo')")
                img(src='/new/img/tab/c-bingo.png')
                | bingo
            .swiper-slide
              .cat(@click="redirectPath('/fishing')")
                img(src='/new/img/tab/c-fish.png')
                | fishing
            .swiper-slide
              .cat(@click="redirectPath('/minigame')")
                img(src='/new/img/tab/c-arcade.png')
                | minigame
            //- .swiper-slide
              .cat(@click="redirectPath('/crash')")
                img(src='/new/img/tab/c-crash.png')
                | crash
            //- .swiper-slide
              .cat(@click="redirectPath('/lottery')")
                img(src='/new/img/tab/c-lottery.png')
                | lottery
        .swiper-button-prev.glcat-swiper-prev
        .swiper-button-next.glcat-swiper-next
      template
        .searchbar
          .fav.pointer(v-if="isLoggedIn" @click="toggleFav")
            i.fa-heart(:class="{'fa-solid fav-red': showFav, 'fa-regular': !showFav}")
          .fav.pointer(v-if="!isLoggedIn" @click="$router.push('/login').catch(err => {})")
            i.fa-regular.fa-heart
          input.form-control(type='text' v-model="searchinput" placeholder='Search')
          .s-icon
            i.fa-solid.fa-magnifying-glass
        .glmenu.nbswi.mt-2
          .swiper.glpro-swiper.nbswi-swiper
            .swiper-wrapper
              .swiper-slide(@click="changeProvider(0)")
                .g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 0, 'c-filter2': providerSelected !== 0}")
                  img(:src="getImg('evo')")
              .swiper-slide(@click="changeProvider(1)")
                .g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 1, 'c-filter2': providerSelected !== 1}")
                  img(:src="getImg('winfinity')")
              .swiper-slide(@click="changeProvider(2)")
                .g-pro.pro(:class="{'aaa' : providerSelected === 2}")
                  img(:src="getImg('yeebet')")
              .swiper-slide(@click="changeProvider(3, 'PP-C1', 'pragmatic')")
                .g-pro.pro(:class="{'aaa c-filter' : providerSelected === 3, 'c-filter1': providerSelected !== 3}")
                  img(:src="getImg('pragmatic')")
              //- .swiper-slide(@click="changeProvider(4, 'MG-C1', 'microgaming')")
                .g-pro.pro(:class="{'aaa' : providerSelected === 4}")
                  img(:src="getImg('microgaming')")
              .swiper-slide(@click="changeProvider(5, 'EZUGI', 'ezugi')")
                .g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 5, 'c-filter2': providerSelected !== 5}")
                  img(:src="getImg('ezugi')")
              //- .swiper-slide(@click="changeProvider(6, 'GPK7MJ-C1', '7mojo')")
                .g-pro.pro(:class="{'aaa' : providerSelected === 6}")
                  img(:src="getImg('7mojo')")
              //- .swiper-slide(v-for="(provider, index) in providerList" @click="changeProvider(provider.provider_code)")
                .g-pro.pro(:class="{'aaa' : providerSelected === provider.provider_code, 'c-filtera': (providerSelected === provider.provider_code) && customImg.includes(provider.provider_code) , 'c-filter2': (providerSelected !== provider.provider_code) && customImg.includes(provider.provider_code)}")
                  img(:src="getImg(provider.provider_code)")
          .swiper-button-prev.glpro-swiper-prev
          .swiper-button-next.glpro-swiper-next
        favList(v-if="showFav" :searchinput="searchinput")
        //- gameList(v-if="!showFav && pageLoading==false" :searchinput="searchinput" :gameType="'livecasino'" :pCode="providerSelected" :key="providerSelected")
        evolive(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
        wify(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
        yb(v-if="providerSelected === 2 && !showFav" :searchinput="searchinput")
        oneApi(v-if="providerSelected > 2 && !showFav" :searchinput="searchinput" :pCode="providerCode" :gameType="'LIVE'" :imgName="imgName" :key="providerCode")
      //- template(v-else)
        .text-center.text-white.my-4.w-100
          i.fa-regular.fa-newspaper.display-6.text-black
          .text-black No data
      footerInfo(:target="'/casino'")
</template>
<script>
import { EventBus } from '@/store/event';
import topbar from '@/views/default/_topBar.vue'
import highlight from '@/component/_highlight.vue'
import rtt from '@/component/_realTimeTrans.vue'
import favList from '@/component/casino/_favList.vue'
import config from "@/config";
import footerInfo from '@/views/default/_footerArticle.vue'
import imgList from '@/providerImg'
// import gameList from '@/component/_gameList.vue'
import social from '@/component/_social.vue'
import googleSearch from '@/component/_googleSearch.vue'
import evolive from '@/component/casino/_evolive.vue'
import wify from '@/component/casino/_wify.vue'
import yb from '@/component/casino/_yb.vue'
import oneApi from '@/component/_oneApi.vue'
export default {
  components:{
    topbar,
    highlight,
    rtt,
    footerInfo,
    favList,
		imgList,
		// gameList,
    social,
    googleSearch,
    evolive,
    wify,
    yb,
    oneApi
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading:false,
      showMobile: false,
      providerSelected: 0,
      showSearch: false,
      searchinput:"",
      showFav: false,
      providerImg: imgList.provider,
      pageLoading:true,
      providerList:[],
      customImg:['EVOLIVE-AIO', 'EZG-AIO'],
      providerCode: "",
			imgName: ""
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
  },
  watch:{
    sessionToken(newState, oldState){
      this.showFav = false
    }
  },
  created(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/casino`);
  },
  mounted(){
    EventBus.$on("toTop", (data) => {
			if(data == true){
				if(window.innerWidth >= 768){
          window.scroll(0,200)
        }else{
          window.scroll(0,0)
        }
			}
		});
    // EventBus.$on("scroll", (data) => {
		// 	if(data == true){
		// 		this.$nextTick(() => {
		// 			// then wait for the browser’s layout/paint
		// 			requestAnimationFrame(() => {
		// 				setTimeout(this.scrolltoDiv, 500)
		// 			})
		// 		})
		// 	}
		// });
    if ($('.glcat-swiper').length) {
			const gboxSwiper = new Swiper('.glcat-swiper', {
				slidesPerView: 4.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glcat-swiper-next',
					prevEl: '.glcat-swiper-prev'
				},
				// watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: {
						slidesPerView: 4.5
					},
					960: {
						slidesPerView: 6
					}
				}
			})
    }
    if ($('.glpro-swiper').length) {
        const gboxSwiper = new Swiper('.glpro-swiper', {
					slidesPerView: 3.5,
					spaceBetween: 4,
					navigation: {
							nextEl: '.glpro-swiper-next',
							prevEl: '.glpro-swiper-prev'
					},
					watchOverflow: true,
					autoplay:false,
					breakpoints: {
							768: {
									slidesPerView: 6.5
							},
							960: {
									slidesPerView: 6.5
							}
					}
			})
		}
    // this.getProviderlist()
  },
  methods:{
    initSwiper(){
			// if (this.gboxSwiper) this.gboxSwiper.destroy(true,true)
			const gboxSwiper = new Swiper('.glpro-swiper', {
				slidesPerView: 3.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glpro-swiper-next',
					prevEl: '.glpro-swiper-prev'
				},
				watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: { slidesPerView: 6.5 },
					960: { slidesPerView: 6.5 }
				},
				// make Swiper react to DOM changes
				observer: true,
				observeParents: true,
				observeSlideChildren: true,
			})
		},
    redirectPath(target){
      this.$router.push(target).catch(error =>{}).finally(() => {
        this.$nextTick(() => {
          EventBus.$emit('scroll', true);
        });
      });
    },
		scrolltoDiv(){
			const el = this.$refs.categories
      if (!el) return
			
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest"  })
		},
    openModal(){
      $("#logModal").modal('show')
    },
    toggleFav(){
      this.showFav = !this.showFav
    },
    toggleSearch(){
      this.showSearch = !this.showSearch
    },
    cancelSearch(){
      this.showSearch = false
      this.searchinput = ""
    },
    changeProvider(option, code, img){
      if(option !== this.providerSelected){
        this.providerSelected = option
      }
      if(code){
				this.providerCode = code
			}
			if(img){
				this.imgName = img
			}
      this.showFav = false
      // if(option === this.providerSelected){
      // 	return
      // }else{
      // 	this.providerSelected = option
      // }
    },
    getProviderlist(){
      this.pageLoading = true
			var url = config.getProviderlist()
      this.$http.post(url, {
        "category": "LIVECASINO"
      }).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
							if(successResponse.data.value.length > 0){
								this.providerList = successResponse.data.value
								this.providerSelected = this.providerList[0].provider_code
                this.$nextTick(this.initSwiper)
							}
            } else {
            }
						this.pageLoading = false
          }else{
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    getImg(code){
			return `/new/img/provider/${code}.png`
		}
  }
}
</script>
  